import { Routes } from "@angular/router";
import { WorkflowCspAiTariffOrderCancelComponent } from "./workflow-csp-ai-tariff-order-cancel.component";


export const WorkflowCspAiTariffOrderCancelRouting: Routes = [
    {
        path: 'csp/change-ai-tariff/:aid/order-cancel', component: WorkflowCspAiTariffOrderCancelComponent
    },
]